import { AwsRum, AwsRumConfig } from "aws-rum-web";

let awsRum: AwsRum | null = null;

const APP_MONITOR_ID = "";
const IDENTITY_POOL_ID = "";
const REGION = "us-east-1";
const RUM_ENABLED_DOMAINS = ""
  .split(",")
  .map((domain) => domain.trim())
  .filter(Boolean);

export const isRumEnabledForHostname = (
  hostname: string,
  enabledDomains: string[] = RUM_ENABLED_DOMAINS,
): boolean => enabledDomains.some(
  (domain) => domain.toLowerCase() === hostname.toLowerCase(),
);

if (
  process.env.NODE_ENV === "production"
  && isRumEnabledForHostname(window.location.hostname)
) {
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId: IDENTITY_POOL_ID,
      endpoint: `https://dataplane.rum.${REGION}.amazonaws.com`,
      telemetries: ["errors", "http", "performance"],
      allowCookies: true,
      enableXRay: false,
    };

    awsRum = new AwsRum(APP_MONITOR_ID, "1.0.0", REGION, config);
  } catch (error) {
    console.error("Failed to initialize CloudWatch RUM:", error);
  }
}

export { awsRum };
